
export enum TicketMediaType {
    CARD = 0,
    BARCODETICKET = 1,
    PAPERTICKET = 2,
}

export enum TicketFlag {
    ACTIVE = 0,
    EXTERNALBARCODE = 4,
    TRANSFERRED = 8,
    CALLBACK = 16,
    PENDING = 32,
    ONSALE = 2048,
    SOLD = 4096,
    DONATED = 32768,
    DISTRIBUTED = 65536,
    SHARED = 262144,
}

export enum TicketActionType {
    TransferToEmail = 0,
    TransferToMember = 1,
    Resell = 2,
    Donate = 3,
    Upgrade = 4,
    Callback = 5,
  }